<template>
  <div class="reset-text-align d-flex justify-content-center">
    <primary-button class="btn-lg" @click="loadForm">
      {{ i18n.t('local_chapters.show.join') }}
    </primary-button>

    <toast v-if="showError" kind="error" @hidden="errorMessage = null">
      <template #message-content>
        {{ errorMessage }}
      </template>
    </toast>

    <authenticate-to-continue-modal v-if="showAuthenticateToContinueModal" :closeable="true"
                                    :description="i18n.t('public.groups.join.authenticate_explanation')"
                                    :authentication-modal-data="authenticationModalData"
                                    @authenticated="authenticated"
                                    @modal-closed="authenticationModalClosed" />

    <join-modal v-if="showJoinModal" @closed="joinModalClosed" @group-member-created="groupMemberCreated" />
  </div>
</template>

<script>
import ajax from '@/helpers/ajax'
import AuthenticateToContinueModal from '@/users/authenticate-to-continue-modal'
import JoinModal from './join-modal'
import { mapMutations, mapState } from 'vuex'
import PrimaryButton from '@/components/buttons/primary-button'
import Toast from '@/components/toast'

export default {
  components: { AuthenticateToContinueModal, JoinModal, PrimaryButton, Toast },

  data() {
    return {
      authenticationModalData: null,
      errorMessage: null,
      showAuthenticateToContinueModal: false,
      showJoinModal: false
    }
  },

  computed: {
    ...mapState(['groupMembersUrl']),

    showError() {
      return this.errorMessage !== null
    }
  },

  methods: {
    ...mapMutations(['setUserIsLoggedIn', 'setDataProcessingConsentProps']),

    authenticated() {
      this.setUserIsLoggedIn(true)
      this.authenticationModalClosed()
      this.loadForm()
    },

    authenticationModalClosed() {
      this.showAuthenticateToContinueModal = false
    },

    groupMemberCreated() {
      // The "group member" view of the group page is very different from the "not a member" view.
      // The user just joined the group, so reload the page so they can see the "group member" view.
      document.location.reload()
    },

    joinModalClosed() {
      this.showJoinModal = false
    },

    loadForm() {
      ajax.get({
        url: `${this.groupMembersUrl}/new`,
        successHandler: (response) => {
          if (response.requiresAuthentication) {
            this.authenticationModalData = response.authenticationModalData
            this.showAuthenticateToContinueModal = true
          } else {
            if (response.userIsGroupMember) {
              // It turns out the user has already joined this group! So they cannot join it again.
              // Reload the page so they get the "member" view, and don't do anything else.
              document.location.reload()
              return
            }

            this.setDataProcessingConsentProps(response.dataProcessingConsentProps)
            this.showJoinModal = true
          }
        },
        errorHandler: ({ message }) => {
          this.errorMessage = message
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reset-text-align {
  text-align: initial;
}
</style>
